import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestionTableColumnNames, fetchAllQuestions, createQuestions, updateQuestions, deleteQuestions, activateDeactivateQuestions, 
    updateUserPreference, getQuestionTypes, getDifficultyLevel, fetchAllQuestionCategory, questionOptions, 
    fetchAllScore,
    fetchSubTopic,
    fetchTopics,
    fetchAllSubTopics,
    fetchAllTopics,
    fetchTranslation} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import ViewModal from "../../../Components/Common/Modal/ViewModal";
import AddQuestionForm from "../../../Components/Common/AddQuestionForm/AddQuestionForm";
import AddAiQuestionForm from "../../../Components/Common/AddQuestionForm/AddAiQuestionForm";
import AddQuestionOptionForm from "../../../Components/Common/AddQuestionForm/AddQuestionOptionForm";
import { toast } from "react-toastify";
import { clearAiQuestionsState } from "../../../slices/questions/reducer"; 
import { clearQuestionHintsState } from "../../../slices/questionHints/reducer"; // Adjust path if needed
import QuestionHints from "./QuestionHints";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import { GetAllTopics } from "../../../helpers/fakebackend_helper";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import AddAIQuestionForm from "../../../Components/Common/AddQuestionForm/AddAiQuestionForm";
import { ErrorMessage } from "formik";


const labels = [
  {
    id: 1,
    labelName: "Name Of Problem English",
    fieldName: "text-box-translate",
    name: "QuestionTitleEn",
    value: "QuestionTitleEn",
    required: true,
    translateTo:"QuestionTitleAr",
    errorMessage: "Name Of Problem English Is Required"
  },
  {
    id: 2,
    labelName: "Name Of Problem Arabic",
    fieldName: "text-box",
    name: "QuestionTitleAr",
    value: "QuestionTitleAr",
    required: true,
    errorMessage: "Name Of Problem Arabic Is Required" 
  },
  {
    id: 3,
    labelName: "Description English",
    // fieldName: "textarea-box",
    fieldName: "editor",
    name: "QuestionDescriptionEn",
    value: "QuestionDescriptionEn",
    required: true,
    errorMessage: "Description English Is Required" 
  },
  {
    id: 4,
    labelName: "Description Arabic",
    // fieldName: "textarea-box",
    fieldName: "editor",
    name: "QuestionDescriptionAr",
    value: "QuestionDescriptionAr",
    required: true,
    errorMessage: "Description Arabic Is Required" 
  },
//   {
//     id: 5,
//     labelName: "SolutionEnglish",
//     fieldName: "textarea-box",
//     name: "SolutionEn",
//     value: "SolutionEn",
//     required: true,
//   },
//   {
//     id: 6,
//     labelName: "SolutionArabic",
//     fieldName: "textarea-box",
//     name: "SolutionAr",
//     value: "SolutionAr",
//     required: true,
//   },
  {
    id: 6,
    labelName: "Topics",
    fieldName: "topic-dropdown",
    name: "TopicID",
    value: "TopicID",
    required: true,
    errorMessage: "Topics Is Required" 
  },
  {
    id: 7,
    labelName: "Sub Topics",
    fieldName: "sub-topic-dropdown",
    name: "SubTopicID",
    value: "SubTopicID",
    required: true,
    errorMessage: "Sub Topics Is Required" 
  },
  {
    id: 8,
    labelName: "Type",
    fieldName: "type-dropdown",
    name: "QuestionTypeID",
    value: "QuestionTypeID",
    required: true,
    errorMessage: "Type Is Required" 
  },
  {
    id: 10,
    labelName: "Difficulty",
    fieldName: "level-dropdown",
    name: "DifficultyLevel",
    value: "DifficultyLevel",
    required: true,
    errorMessage: "Difficulty Is Required" 
  },
  // {
  //   id: 11,
  //   labelName: "Score",
  //   fieldName: "number-box",
  //   name: "Score", 
  //   value: "Score",
  //   required: true,
  // },
];

const labelsAi = [
  {
    id: 1,
    labelName: "Topic",
    fieldName: "topic-dropdown",
    name: "Topic",
    value: "Topic",
    required: false,
  },
  {
    id: 2,
    labelName: "Sub Topic",
    fieldName: "sub-topic-dropdown",
    name: "SubTopic",
    value: "SubTopic",
    required: false,
  },
  {
    id: 3,
    labelName: "Type",
    fieldName: "type-dropdown",
    name: "Type",
    value: "Type",
    required: false,
  },
  {
    id: 4,
    labelName: "Difficulty",
    fieldName: "difficulty-dropdown",
    name: "Difficulty",
    value: "Difficulty",
    required: false,
  },
  {
    id: 5,
    labelName: "Number of Questions",
    fieldName: "number-box-with-fetch-button",
    name: "Numbercount",
    value: "Numbercount",
    required: false,
  },
  {
    id: 6,
    labelName: "Question",
    fieldName: "question-list",
    name: "QuestionIDs", // Changed from QuestionID
    value: "QuestionIDs", // Changed from QuestionID
    required: true,
  }
];

const hintlabels = [
  {
    id: 1,
    labelName: "Hint English",
    fieldName: "editor",
    name: "HintEn",
    value: "HintEn",
    required: true,
  },
  {
    id: 2,
    labelName: "Hint Arabic",
    fieldName: "editor",
    name: "HintAr",
    value: "HintAr",
    required: true,
  },
]
const solutionlabels = [
  {
    id: 1,
    labelName: "Solution English",
    fieldName: "editor",
    name: "SolutionEn",
    value: "SolutionEn",
    required: true,
  },
  {
    id: 2,
    labelName: "Solution Arabic",
    fieldName: "editor",
    name: "SolutionAr",
    value: "SolutionAr",
    required: true,
  },
]


const optionLabels = [
    {
      id: 1,
      labelName: "Question",
      fieldName: "text-box",
      name: "QuestionTitle",
      value: "QuestionTitle",
      required: false,
    },
    {
      id: 2,
      labelName: "Options",
      fieldName: "option-box",
      name: "Options",
      value: "Options",
      required: true,
    }
]

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};

function Questions () {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {user} = getAuthUser();
  const [show, setShow] = useState(false);
  const [showSolution, setShowSolution] = useState(false);
  const [show1, setShow1] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isAiFormSubmitDisabled, setIsAiFormSubmitDisabled] = useState(true);
  const [aiGeneratedQuestions, setAiGeneratedQuestions] = useState([]); 
  const [lastTranslatedField, setLastTranslatedField] = useState(null);

  const { Questions, tableColumnNames, loading, headerLoad, module, aiQuestions, loadingAi, topicsList, subTopics, QuestionTypes, DifficultyLevel, questionsScore, translationLoading  } = useSelector((state) => ({
    Questions: state.Questions.questions,  
    tableColumnNames: state.Questions.tableColumnNames,
    loading: state.Questions.loading,
    headerLoad: state.Questions.headerLoad,
    module: state.Module.module,
    aiQuestions: state.Questions.aiQuestions,
    loadingAi: state.Questions.loadingAi,
    questionsScore: state.Questions.questionsScore,
    topicsList: state.Topics.topicsList,  
    subTopics: state.SubTopics.subTopics,   
    QuestionTypes: state.Common.questionTypes,
    DifficultyLevel: state.Common.difficultyLevel,
    translationLoading: state.Module.translationLoading, 
  }));  

  // Compute permission
  const permission = (() => {
    const moduleItem = module?.find(
      (m) => m.moduleId === 10 && m.modulePermission?.CanView
    );
    const pageItem = moduleItem?.pages?.find((p) => p.pageId === 9); // Roles Management = pageId: 2

    if (moduleItem && pageItem) {
      return {
        CanView:
          moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
        CanAdd:
          moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
        CanEdit:
          moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
        CanDelete:
          moduleItem.modulePermission.CanDelete &&
          pageItem.permissions.CanDelete,
        CanActive:
          moduleItem.modulePermission.CanActive &&
          pageItem.permissions.CanActive,
      };
    }

    return {};
  })();

    const handleButtonClick = (question, type) => {

        if (question.NoOfOptions == 0) {
            setSelectedRow({
                ...question,
                Options: [
                    { OptionEn: "", OptionAr: "", IsCorrect: false },
                    { OptionEn: "", OptionAr: "", IsCorrect: false },
                    { OptionEn: "", OptionAr: "", IsCorrect: false },
                    { OptionEn: "", OptionAr: "", IsCorrect: false }
                ]
            })
        } else {
            setSelectedRow(question);
        }
      
        if (type === 'HintEn') {
            setShowHint(true);  
        } else if(type === 'SolutionEn') {
            setShowSolution(true);
        }else{
            setShowOptions(true);
        }
    }

    const onAddClickHandler = (value) => {
        setShow(true);
        setIsAddOrEdit(value);
        // For regular add, selectedRow is empty, AI form submit disabled state is separate
        setSelectedRow({});
    };

    const onEditClickHandler = (question, value) => {
        setSelectedRow(question);
        setIsAddOrEdit(value);
        setShow(true);
    };

    const onAiModalOpenHandler = () => {
      setShow1(true);
      setIsAiFormSubmitDisabled(true); 
      dispatch(clearAiQuestionsState());
    };
  
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    let scoreIdToSet = selectedRow.ScoreID;
    let scoreValueToSet = selectedRow.Score;
  
    setSelectedRow((prev) => ({
      ...prev,
      [name]: value
    }));
  
    // Check if Difficulty or Type changed and both have values
    const newDifficulty = name === 'DifficultyLevel' ? value : selectedRow.DifficultyLevel;
    const newType = name === 'QuestionTypeID' ? value : selectedRow.QuestionTypeID;

    if (newDifficulty && newType) {
      const matchedScore = questionsScore.find(
        (score) => score.DifficultyLevel == newDifficulty && score.QuestionTypeID == newType
      );
      scoreIdToSet = matchedScore ? matchedScore.ID : null;
      scoreValueToSet = matchedScore ? matchedScore.Mark : '';
    } else {
      scoreIdToSet = null; 
      scoreValueToSet = '';
    }
    
    // Update state with potentially new score details
    setSelectedRow((prev) => ({
      ...prev,
      [name]: value,
      ScoreID: scoreIdToSet, 
      Score: scoreValueToSet 
    }));
  };
  
  const onActiveOrDeactiveChange = (question, e) => {
    dispatch(activateDeactivateQuestions({ ID: question.ID, IsActive: question.IsActive, UserId: user.UserId }));
  };
  
  const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
  if (!textToTranslate || textToTranslate.trim() === "") {
    toast.error(t("EnterTextToTranslate"));
    return;
  }
  setLastTranslatedField(sourceFieldName); 

  dispatch(fetchTranslation({ LangText: textToTranslate }))
    .unwrap() 
    .then(translatedText => {
      formikSetFieldValue(targetField, translatedText);
    })
    .catch(error => {
      console.error("Translation error:", error);
      toast.error(t("TranslationFailed"));
    })
    .finally(() => {
      setLastTranslatedField(null); 
    });
};
  
  const onSubmitHandler = (values, { resetForm, setSubmitting }) => {
    setSubmitting(true);
   try {
      const questionObj = {
        QuestionTitleEn: values.QuestionTitleEn,
        QuestionTitleAr: values.QuestionTitleAr,
        QuestionDescriptionEn: values.QuestionDescriptionEn,
        QuestionDescriptionAr: values.QuestionDescriptionAr,
        TopicID: values.TopicID,
        SubTopicID: values.SubTopicID,
        QuestionTypeID: values.QuestionTypeID,
        DifficultyLevel: values.DifficultyLevel,
        IsScore: false, // Adjust if score is managed through this form
        // ScoreID: values.ScoreID, // If applicable
        // Score: values.Score,       // If applicable
      };

      if (isAddOrEdit === "isEdit" && selectedRow?.ID) {
        questionObj.ID = selectedRow.ID;
        dispatch(updateQuestions(questionObj))
      } else {
        dispatch(createQuestions(questionObj))
      }
      setShow(false);
      setSubmitting(false);
      resetForm();
    } catch (error) {
      console.error("Error submitting question:", error);
      toast.error(t("SubmissionFailed") + (error?.message ? `: ${error.message}` : ''));
    }
  };

  // Unified update function
  const handleQuestionUpdate = (questionId, updatedFields) => {

    if (!questionId) {
      toast.error("Question ID is missing for update.");
      return;
    }

    const payload = {
      ...updatedFields,
      ID: questionId,
    };
    dispatch(updateQuestions(payload));
  };

  const onSubmitAiQuestionHandler = (formikValues, { resetForm }) => {
    // e.preventDefault(); // Not needed with Formik's onSubmit

    if (!formikValues?.QuestionIDs || formikValues.QuestionIDs.length === 0) {
      toast.warn("No questions selected to add.");
      return;
    }

    const questionsToAdd = aiGeneratedQuestions.filter(q =>
        formikValues.QuestionIDs.includes(q.ID) // Use ID from aiGeneratedQuestions which should match selected IDs
    );
    const quetions = questionsToAdd.reduce((acc, question) => {

        const TopicID = topicsList.find(cat =>
          cat.TopicNameEn.toLowerCase() === question.topic?.toLowerCase()
        )?.ID || 1;

        const SubTopicID = subTopics.find(cat =>
          cat.SubTopicNameEn.toLowerCase() === question.SubTopic?.toLowerCase()
        )?.ID || 1;

        const questionTypeID = QuestionTypes.find(type =>
          type.NameEn.toLowerCase() === question.type?.toLowerCase()
        )?.ID ;
      
        const difficultyLevelID = DifficultyLevel.find(diff =>
          diff.NameEn.toLowerCase() === question.difficulty?.toLowerCase()
        )?.ID ;

        
        const questionObj = {
          
            
            QuestionTitleEn: question.question_title_english,
            QuestionTitleAr: question.question_title_arabic,
            QuestionDescriptionEn: question.question_discription_english, 
            QuestionDescriptionAr: question.question_discription_arabic,
            SolutionEn: question.solution_english,
            SolutionAr: question.solution_arabic,
            TopicID: TopicID || 0, 
            SubTopicID: SubTopicID || 0, 
            QuestionTypeID: questionTypeID || 11,
            DifficultyLevel: difficultyLevelID || 5,
            answers: question.answers.map(ans => ({
              OptionEn: ans.answer_english,
              OptionAr: ans.answer_arabic,
              IsCorrect: ans.isCorrect
            })),
            HintEn: question.hint_english,
            HintAr: question.hint_arabic,
        };
        
        acc.push(questionObj);
        return acc;
      }, []);
      
      dispatch(createQuestions({ Questions: quetions })) 

    dispatch(clearAiQuestionsState());
    setShow1(false);
    resetForm(); 
  };

  const onSubmitOptionHandler = (e) => {
    e.preventDefault();

    const questionObj = {
        QuestionID: selectedRow.ID,
        Options: selectedRow.Options,
    }

    dispatch(questionOptions(questionObj));
    setShowOptions(false);
  }

  // Handler for Hint Modal submission
  const onSubmitHintHandler = (values) => {

    const updatedFields = {
      HintEn: values.HintEn,
      HintAr: values.HintAr,
    };
    handleQuestionUpdate(selectedRow.ID, updatedFields); 
    setShowHint(false); 
  };  
  
  // Handler for Solution Modal submission
  const onSubmitSolutionHandler = (values) => {

    const updatedFields = {
      SolutionEn: values.SolutionEn,
      SolutionAr: values.SolutionAr,
    };
    handleQuestionUpdate(selectedRow.ID, updatedFields); 
    setShowSolution(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchQuestionTableColumnNames({
          module: "QUESTIONS"
        })
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteQuestions({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  // Handler for inline score update
  const handleScoreUpdate = (item, columnKey, newValue) => {
    if (columnKey === 'Score') {
      const scoreValue = parseInt(newValue, 10);

      if (!isNaN(scoreValue)) {
        handleQuestionUpdate(item.ID, {
          Score: scoreValue,
          IsScore: true,
        });
      } else {
        toast.warn("Invalid score value.");
      }
    }
  };

  // Handler for closing the AI modal
  const handleAiModalClose = (isOpen) => {
    setShow1(isOpen);
    if (!isOpen) { // Clear state when modal is closed, not opened
      dispatch(clearAiQuestionsState());
      setSelectedRow({}); 
    }
  };
  
  useEffect(() => {
    dispatch(fetchQuestionTableColumnNames({ module: "QUESTIONS" }))
    dispatch(fetchAllQuestions());
    dispatch(fetchAllScore());
    dispatch(fetchAllTopics({IsActive: true}));
    dispatch(fetchAllSubTopics({IsActive:true}));
    dispatch(getQuestionTypes())
    dispatch(getDifficultyLevel())

  }, [dispatch]);

  // Effect to update local AI questions state when fetched from Redux
  useEffect(() => {
    if (aiQuestions) {
        const questionsWithIds = aiQuestions.map((q, index) => ({
            ...q,
            ID: index
        }));
        setAiGeneratedQuestions(questionsWithIds);
    } 
  }, [aiQuestions]);



  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Questions")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}

                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={onAiModalOpenHandler}
                          id="create-btn"
                        >
                          {/* <i className="ri-add-line align-bottom me-1 ms-1"></i> */}
                          {t("AIQuestionBanck")}
                        </Button>
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || headerLoad ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={Questions}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      onInlineUpdate={handleScoreUpdate} 
                      handleButtonClick={handleButtonClick}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                    <CommonDataTable
                        data={Questions}
                        tableColumnNames={tableColumnNames}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                        onInlineUpdate={handleScoreUpdate} 
                        handleButtonClick={handleButtonClick}
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        actionConfig={actionConfig}
                        permission={permission}
                      />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Add Question Modal  */}
      {/* <AddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        title={isAddOrEdit === "isAdd" ? t("Add New Question") : t("Edit Question")}
        modalBody={
          <AddQuestionForm
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            questionsScore={questionsScore}
            onChangeHandler={onChangeHandler}
          />
        }
      /> */}
        <CommonAddModal
          show={show}
          setShow={setShow}
          onSubmitHandler={onSubmitHandler}
          labels={labels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          title={isAddOrEdit === "isAdd" ? t("Add New Question") : t("Edit Question")}
          FormBody={AddQuestionForm}
          FormBodyProps={{ 
            onTranslateClickHandler, 
            translationLoading,
            lastTranslatedField: lastTranslatedField,
          }} 
          size="xl"
          fullscreen = {false}
          backdrop={'static'}
        />

      {/* Add Ai Question Modal */}
      <CommonAddModal
        show={show1}
        setShow={setShow1}
        onSubmitHandler={onSubmitAiQuestionHandler}
        isDisabled={isAiFormSubmitDisabled} 
        labels={labelsAi}
        isAddOrEdit={"isAdd"} 
        selectedItemData={{ QuestionIDs: selectedRow.QuestionIDs || [] }} 
        FormBody={AddAIQuestionForm}
        FormBodyProps={{ setParentSubmitDisabled: setIsAiFormSubmitDisabled, skipValidation: true }}
        title={t("AI Question Bank")}
        size="xl"
        fullscreen = {false}
        backdrop={'static'}
        skipValidation={true} // Add this prop
      />


      {/* Show Question Options Modal */}
      <AddModal
        show={showOptions}
        setShow={setShowOptions}
        onSubmitHandler={onSubmitOptionHandler}
        title={isAddOrEdit === "isAdd" ? t("Add New Question Option") : t("Edit Question Option")}
        modalBody={
          <AddQuestionOptionForm
            labels={optionLabels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            onChangeHandler={onChangeHandler}
          />
        }
      />
       {/* <CommonAddModal
          show={showOptions}
          setShow={setShowOptions}
          onSubmitHandler={onSubmitOptionHandler}
          labels={optionLabels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          FormBody={AddQuestionForm}
          // FormBodyProps={{ 
          //   onTranslateClickHandler, 
          //   translationLoading,
          //   lastTranslatedField: lastTranslatedField,
          // }} 
          size="lg"
          fullscreen = {false}
          backdrop={'static'}
        /> */}

      {/* Show Hint Modal */}
      {/* <AddModal
        show={showHint}
        setShow={setShowHint}
        onSubmitHandler={onSubmitHintHandler} 
        title={isAddOrEdit === "isAdd" ? t("Add New Question Hints") : t("Edit Question Hints")}
        modalBody={
          <AddCommonForm2
            labels={hintlabels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            onChangeHandler={onChangeHandler}
          />
        }
      /> */}

       <CommonAddModal
          show={showHint}
          setShow={setShowHint}
          onSubmitHandler={onSubmitHintHandler}
          labels={hintlabels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          FormBody={AddQuestionForm}
          // FormBodyProps={{ 
          //   onTranslateClickHandler, 
          //   translationLoading,
          //   lastTranslatedField: lastTranslatedField,
          // }} 
          size="xl"
        />

      {/* Show Solution Modal */}
      {/* <AddModal
        show={showSolution}
        setShow={setShowSolution}
        onSubmitHandler={onSubmitSolutionHandler} // Use dedicated solution handler
        title={isAddOrEdit === "isAdd" ? t("Add New Question solution") : t("Edit Question solution")}
        modalBody={
          <AddCommonForm2
            labels={solutionlabels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            onChangeHandler={onChangeHandler}
          />
        }
      /> */}
       <CommonAddModal
          show={showSolution}
          setShow={setShowSolution}
          onSubmitHandler={onSubmitSolutionHandler}
          labels={solutionlabels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          FormBody={AddQuestionForm}
          // FormBodyProps={{ 
          //   onTranslateClickHandler, 
          //   translationLoading,
          //   lastTranslatedField: lastTranslatedField,
          // }} 
          size="xl"
        />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={t("Are you sure you want to delete this record?")}
      />

      {/* <Quiz /> */}
    </div>
  );
}

export default Questions;